// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"453":"b52b8293","630":"241940b7"}[chunkId] + ".chunk.css";
};